export const ALLOWED_SMART_ACTION_TYPES = {
  DRIP: 'drip',
  TIME_LAPSED: 'time-lapsed',
};
